module.exports = __webpack_public_path__ + "img/icon7.906dddab.png";